import React, { useContext } from 'react';
import { ApiGetCall } from '../../JS/Connector';
import { formatDateToMMDDYYYY } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import GreyBoxForReports from './GreyBoxForReports';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';

export default function MassDevices({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    const {organization, with_student_device_count_label, without_student_device_count_label} = useConfig();
    async function GetDeviceData() {
        setLoading(true);
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        await ApiGetCall(`/reports/device-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&flag=${downloadall}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    DownloadCsv(responseRs);
                } else {
                    DownloadCsv([]);
                    setalerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
                    setTimeout(() => {
                        setalerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            }
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            const rowData = {
                [`${organization} Name`]: item.school_name,
                'Total Devices': item.total_device_count,
                [with_student_device_count_label]: item.with_student_device_count,
                [without_student_device_count_label]: item.without_student_device_count,
            };
            PurchaseMap.push(rowData);
        });

        if (PurchaseMap.length > 0) {
            const headers = [`${organization} Name`, 'Total Devices',
            with_student_device_count_label,
            without_student_device_count_label
            ];
            csvContent.push(headers);
            PurchaseMap.forEach((rowData) => {
                const values = Object.values(rowData).map(value => {
                    if (typeof value == 'string' && value.includes(',')) {
                        return `"${value}"`;
                    }
                    return value;
                });
                csvContent.push(values);
            });
            csvContent.push([]);
            const csvString = csvContent.map((row) => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'BulkDevices.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            log.error('No data available for download.');
        }
    };
    return (
        <GreyBoxForReports icon="faDesktop" name={"Bulk Devices Report Download"} onclickfunc={GetDeviceData} />
    )
}
